export default {
  webLive_single_viewing: '单人观看',
  webLive_many_viewing: '多人观看',
  webLive_scanned_code: '已扫码人数：{length}人',
  webLive_zhiniao_scan: "e祺学APP - 扫一扫",
  webLive_start_live: '开始观看直播',
  webLive_select_view: '请选择观看模式',
  webLive_start_live: '开始观看直播',
  webLive_address: "地址：",
  webLive_telephone: '电话：',
  webLive_please_ID: '请输入直播间ID和直播间口令',
  webLive_shibboleth_rules: '直播间口令为6-10位的数字或字母',
  webLive_portal_watch: '智门户仅支持观看，请使用e祺学PC端登录',
  webLive_studio_ID: '直播间ID：',
  webLive_enter_ID: '请输入直播间ID',
  webLive_live_password: '直播间口令：',
  webLive_enter_password: "请输入直播间口令",
  webLive_password_Room: '进入口令直播间',
  webLive_portal_live03: '03Web-智门户直播',
  webLive_show_list03: '0301Web-显示直播列表',
  webLive_check_live0302: '0302Web-查看直播',
  webLive_studio_fulled: '直播间已满员',
  webLive_select_failed: '查询失败，请稍后再试',
  webLive_noreplay: "还没有回放",
  webLive_noLive: "还没有直播",
  webLive_chat: '聊天',
  webLive_new_message: "有新消息",
  webLive_failed_video: '网络异常，获取视频失败，请检查网络后重试',
  webLive_error_get_data: '获取数据出错，请稍后再试',
  webLive_data_wrong: '数据有误',
  webLive_last_one: '已经是最后一个啦~',
  webLive_guangdong: '广东省',
  webLive_shenzhen: '深圳市',
  webLive_nanshan: '南山区',
  webLive_studio_deleted: '直播间被删除',
  webLive_vr_app: "vr直播请移步e祺学app观看",
  webLive_without_power: '没有权限进入',
  webLive_go_app_learn: '该直播间已开启监学，请进入e祺学app进行学习',
  webLive_current_broadcast: "当前直播{liveStatusName}",
  webLive_broadcast_paid: "该直播为付分直播，请登录e祺学APP付费后观看",
  webLive_live_pages08: '08Web-直播间页',
  webLive_show_pages0801: '0801Web-显示直播间页',
  webLive_tourist: '游客',
  webLive_unlock: '开启',
  webLive_switch_video: '切换视频',
  webLive_hide_window: '隐藏小窗口',
  webLive_show_window:'显示小窗口',
  webLive_public_announcement: '公告',
  webLive_anchor_head_sculpture: '主播头像',
  webLive_studio_anchor: '主播:',
  webLive_audience: '观众：',
  webLive_check_out:'签出',
  webLive_check_in:'签到',
  webLive_focus_on_watch:'集中观看',
  webLive_scan_code:'扫码',
  webLive_calculatew_time:'{panelText}后，{flag}计算观看时长',
  webLive_left_scan:'e祺学APP-左上角扫一扫',
  webLive_scanede_num:'已扫码人数：{ userList.length }人',
  webLive_playback_deleted:'回放已删除',
  webLive_playback_ended:'回放已结束',
  webLive_not_send_empty:'请勿发送空消息',
  webLive_send_interactive0803:'0803Web-发送互动',
  webLive_send_message:'发消息',
  webLive_studio_forbidden_speak:'该直播间禁止发言',
  webLive_speak:'快和主播一起互动吧',
  webLive_send_bntn:'发送',
  webLive_play_error:'如直播/回放视频无法观看，请切换至最新版本的IE浏览器登录观看。',
  webLive_not_support_hls:'当前浏览器不支持hls',
  webLive_Esc_quit:'按Esc或双击退出全屏',
  webLive_shrink:'缩小',
  webLive_click_zoom0802:'0802Web-点击缩放',
  webLive_lianmai:'连麦',
  webLive_no_lianmai:'暂无连麦',
  webLive_voice_playing:"语音播放中",
  webLive_failed_get_playback:'网络异常，获取直播回放视频失败，请检查网络后重试',
  webLive_zhiniao_school:'e祺学|学堂',
  webLive_anchor_out:'主播暂时不在',
  webLive_play_btn:'播放按钮',
  webLive_volume:'音量',
  webLive_full_screen:'全屏',
  webLive_enlarge:'放大',
  webLive_got_it:'知道了',
  webLive_version_too_low:'你的浏览器版本太低，请先升级浏览器。',
  webLive_will_quit_learning:'已达培训项目结束时间即将退出学习',
  webLive_failed_punch_in:'打卡失败',
  webLive_validation_failed:'验证失败',
  webLive_code_no_exit:'二维码地址不存在！',
  webLive_upload:'下载到本地',
  webLive_count_time:"确定（{countTime}）",
  webLive_stop:'停止',
  webLive_start:"开始",
  webLive_pay: '该直播为付费直播，请前往app观看',
  webLive_live: '直播',
  webLive_course: '课程',
  webLive_card_status:'学习卡{status}',
  webLive_payed_course:'已购课程'
}
